import { useRef, useState, useEffect } from "react";
import { toast } from "sonner";

export const useSpeech = (onText) => {
  const [listening, setListening] = useState(false);
  const recogRef = useRef(null);
  const cbRef = useRef(onText);
  cbRef.current = onText;

  useEffect(() => () => { try { recogRef.current?.stop(); } catch {} }, []);

  const toggleMic = () => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) { toast.error("Speech recognition is not supported in this browser. Try Chrome."); return; }
    if (listening) { recogRef.current?.stop(); setListening(false); return; }
    const r = new SR();
    r.continuous = true; r.interimResults = true; r.lang = "en-US";
    r.onresult = (e) => {
      let final = "";
      for (let i = e.resultIndex; i < e.results.length; i++) if (e.results[i].isFinal) final += e.results[i][0].transcript;
      if (final) cbRef.current?.(final);
    };
    r.onend = () => setListening(false);
    r.onerror = () => { setListening(false); toast.error("Microphone error — check permissions"); };
    recogRef.current = r; r.start(); setListening(true);
  };

  return { listening, toggleMic };
};
